import React, { useState, useEffect, useRef } from "react";
import arrowDropDown from "../assets/arrow_drop_down.svg";
import arrowDropUp from "../assets/arrow_drop_up.svg";
import { questions } from "../VolunteerPageComponentData";
import "./faqsection.css";
import SectionHeader from "../../landingpage/SectionHeader";

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const questionRefs = useRef([]);
  
    const toggleFAQ = (index) => {
      setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

  
    return (
      <section className="faq-section">
        <SectionHeader title="Frequently Asked Questions" />
        <div className="faq-container">
          {questions.map((item, i) => (
            <div key={i} className="faq-item">
              <div
                className="faq-question"
                onClick={() => toggleFAQ(i)}
                ref={(el) => (questionRefs.current[i] = el)}
              >
                <span>{item.question}</span>
                <img src={openIndex === i ? arrowDropUp : arrowDropDown} alt="Toggle arrow" />
              </div>
              <div className={`faq-answer ${openIndex === i ? "open" : ""}`}>
                {openIndex === i && (
                  <div className="faq-content">
                    {item.answer.split("\n").map((para, i) => (
                      <p key={i}>{para}</p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  };
  
  export default FAQSection;